const RolePermissions = {
  viewAccess: true,
  addAccess: true,
  modifyAccess: true,
  exportAccess: true,
  voidAccess: true,
};

export default RolePermissions;
